function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
 
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    //this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const cartDrawer = document.querySelector("cart-drawer .drawer__inner");
    const spinnerContainer = cartDrawer.querySelector(".cart-drawer__spinner-wrapper");
    const previousValue = this.input.value;
    const newPreviousvalue = Number(this.input.getAttribute('data-cart-quantity'));

    spinnerContainer.classList.remove('hide-loader');

    if (event.target.name === 'plus') {
      if (newPreviousvalue < 4) {
        this.input.stepUp();
      } else {
        spinnerContainer.classList.add('hide-loader');
        alert(`Kindly Contact our customer Support team on WhatsApp at +91-9004436043 for bulk buying. Thank you`);
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      //buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      //buttonPlus.classList.toggle('disabled', value >= max);
    } 
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    event.preventDefault();
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

   updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }
  
  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);

        publish(PUB_SUB_EVENTS.variantChange, {data: {
          sectionId,
          html,
          variant: this.currentVariant
        }});
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            this.innerHTML = recommendations.innerHTML;
            const relatedProductSplide = new Splide( '.related-product-splide',{
              mediaQuery: 'min',
              perPage: 1,
              pagination: true,
              padding: { right: 125 } , 
              gap: 15,
              breakpoints: {
                750: {
                    perPage: 4,
                    gap: 30,
                    padding: { right: 0 }
                }
              }
            });
            
            relatedProductSplide.on( 'pagination:mounted', function ( data ) {
            // You can add your class to the UL element
            data.list.classList.add( 'splide__pagination--custom' );
            // `items` contains all dot items
            data.items.forEach( function ( item ) {
              item.button.textContent = String( item.page + 1 )+ "/"+ String(data.items.length);
              });
            });
            relatedProductSplide.mount();
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

//on mobile display search bar 
document.querySelector('.header_search-icon').addEventListener('click',()=>{
  console.log('icon clicked');
  const sectionHeader = document.querySelector(".section-header");
  document.querySelector('.search_bar').classList.toggle('searchDisplay');
  document.querySelector('sticky-header')?.classList.toggle('sticky-header');
  console.log(document.querySelector('.search_bar'), sectionHeader);
  document.querySelector('.st-search-autocomplete').classList.toggle('search-visible')
 if(document.querySelector('.st-search-autocomplete').classList.contains('search-visible')) {
   document.querySelector('.st-search-autocomplete').style.display = "block";
   // document.querySelector('.st-search-autocomplete .st-search-box').focus;
   
 }
  else {
    document.querySelector('.st-search-autocomplete').style.display = "none";
    // document.querySelector('.st-search-autocomplete .st-search-box').blur();
  }
})

// heder account hover and click functionality
let headerIconAccount = document.querySelector('#headerIconAccount')
if(window.innerWidth>990){
  headerIconAccount.addEventListener('mouseenter',()=>{
    headerIconAccount.classList.add('open');
  });
  headerIconAccount.addEventListener('mouseleave',()=>{
    headerIconAccount.classList.remove('open');
  });
} else {
  headerIconAccount.addEventListener('click',()=>{
    if(headerIconAccount.classList.contains('open')){
      headerIconAccount.classList.remove('open')
    }else{
      headerIconAccount.classList.add('open')
    }
  });
}

//splide slider initializaton for special collection section//

// lazy load implementation code
// Shopify.homepageLazyload = function() {
//   // pr-cum-social splide slider initialization
//   let prSocialSplide = document.querySelector('.pr-cum-social-splide');

//   if(prSocialSplide) {
//     const prCumSocial = new Splide( '.pr-cum-social-splide',{})
//     prCumSocial.on( 'pagination:mounted', function ( data ) {
//       // You can add your class to the UL element
//       data.list.classList.add( 'splide__pagination--custom' );
//       // `items` contains all dot items
//       data.items.forEach( function ( item ) {
//         item.button.textContent = String( item.page + 1 )+ "/"+ String(data.items.length);
//       });
//     });
    
//     prCumSocial.mount();    
//   }

//   var reviewStars = document.querySelectorAll(".product-reviews-ratings");
//   for(var i = 0; i < reviewStars.length; i++){
//     var ratingCount = Math.round(reviewStars[i].getAttribute('data-score') * 10) / 10;
//     reviewStars[i].innerHTML = ratingCount + '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" style="fill: rgb(230, 123, 120);transform: ;msFilter:;vertical-align: -1.5;"><path d="M21.947 9.179a1.001 1.001 0 0 0-.868-.676l-5.701-.453-2.467-5.461a.998.998 0 0 0-1.822-.001L8.622 8.05l-5.701.453a1 1 0 0 0-.619 1.713l4.213 4.107-1.49 6.452a1 1 0 0 0 1.53 1.057L12 18.202l5.445 3.63a1.001 1.001 0 0 0 1.517-1.106l-1.829-6.4 4.536-4.082c.297-.268.406-.686.278-1.065z"></path></svg>';
//   }
  
//   const successMessage = document.querySelector('.jsmessage1');
//   const existingMessage = document.querySelector('.jsmessage2');    
//   const url = window.location.href;

//   if (url.includes('?contact%5Btags%5D=newsletter&form_type=customer')) {
//     if (existingMessage) {
//       existingMessage.style.display = 'block';
//       existingMessage.scrollIntoView({ behavior: "smooth", block: "start" }); 
//     }
//   } else if (url.includes('?customer_posted=true')) {
//     if (successMessage) {
//       successMessage.style.display = 'block';
//       successMessage.scrollIntoView({ behavior: "smooth", block: "start" }); 
//     }
//   } else {
//     if (successMessage && existingMessage) {
//       successMessage.style.display = 'none';
//       existingMessage.style.display = 'none';
//     }
//   }
//   typeof(updateProductCards)==='function' && updateProductCards();
// }

// /* load second fold after user interaction */
// function lazyLoadingInit() {
//   const lazyLoadElements = document.querySelectorAll(".custom-lazyloaded-content");
//   let fetchedSections;
  
//   // Custom page fetching
//   (async () => {
//     try {
//       const response = await fetch("/pages/custom-homepage");
  
//       if (!response.ok) {
//         throw new Error(`HTTP error! Status: ${response.status}`);
//       }
  
//       const responseHTML = await response.text();
//       const parser = new DOMParser();
//       const indexLazyLoad = parser.parseFromString(responseHTML, 'text/html');
//       fetchedSections = indexLazyLoad.querySelector("#index-lazyload_sections").innerHTML;
  
//       // Obsorver to check the section for duping the fetch section
//       if (lazyLoadElements.length > 0) {
//         const mainSection = document.querySelector("#st-index");
//         const secoundLastSection = mainSection.children[mainSection.children.length - 2];
  
//         const observer = new IntersectionObserver((entries) => {
//           entries.forEach(entry => {
//             if (entry.isIntersecting && entry.target === secoundLastSection) {
//               loadLazyContentHandler(fetchedSections);
//               observer.disconnect();
//             }
//           });
//         });
  
//         observer.observe(secoundLastSection);
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   })();
  
//   // lazyload handler function
//   function loadLazyContentHandler(content) {
//     lazyLoadElements.forEach(function (element) {
//       element.innerHTML = content;
//     });
  
//     if (lazyLoadElements.length > 0) {
//       Shopify.homepageLazyload();
//     }
//   }
// }

// lazyLoadingInit();
// /* load second fold after user interaction */

// testimonial slider
class TestimonialSplide extends HTMLElement{
  constructor(){
    super()
    this.init()
  }
  init(){
    const testimonialSplide = new Splide( '.testimonial__splide_slider',{
      type: 'slide',
      perPage:3,
      pagination:true,
      autoplay:false,
      interval:1000,
      perMove:3,
      padding: { left:25, right: 25 },
      gap: '3rem',
      breakpoints: {
        750:{
          perPage:2,
          perMove:2,
          gap: '1.5rem',
          padding: {left:0, right: 45 }
          
        },
        480:{
          perPage:1,
          perMove:1,
          gap: '1.5rem',
          padding: {left:0, right: 45 }
        }
      }
    } )
    
    testimonialSplide.on( 'pagination:mounted', function ( data ) {
      // You can add your class to the UL element
      data.list.classList.add( 'splide__pagination--custom' );
      // `items` contains all dot items
      data.items.forEach( function ( item ) {
        item.button.textContent = String( item.page + 1 )+ "/"+ String(data.items.length);
      });
    });
    testimonialSplide.mount(); 
  }
}

customElements.define('testimonial-splide', TestimonialSplide);

//login page
function toggle_visibility(id) {
  var e = document.getElementById(id);
  if (e.style.display === 'block') {
    e.style.display = 'none';
    document.getElementById("CustomerLoginForm").style.display = 'none';
  } else {
    e.style.display = 'block';
    document.getElementById("CustomerLoginForm").style.display = 'none';
  }
  var element = document.querySelector(".success_from");
  if (element.classList.contains("Hide")) {
    element.classList.remove("Hide");
  }
}

function login_toggle_visibility(id) {
  var e = document.getElementById(id);
  if (e.style.display === 'block') {
    e.style.display = 'none';
    document.getElementById("RecoverPasswordForm").style.display = 'none';
  } else {
    e.style.display = 'block';
    document.getElementById("RecoverPasswordForm").style.display = 'none';
  }
}
// sticky filter collection page

// Store the previous scroll position
let prevScrollPos = window.pageYOffset;
const headerContainer = document.querySelector(".header-container");
const tagFilterContainer = document.querySelector(".tag-filter-tab-container");
const headertagFilterContainer = document.querySelector(".tag-filter-tab-container");
const filterObserverElement = document.querySelector(".filter-observer");
const footerObserverElement = document.querySelector(".custom-footer-section");
const hasClass = headerContainer.classList.contains("js-display-none");
const cartProgressBar = document.querySelector("collection-progressbar");
const hasCollectionPage = window.location.href.includes('collections');

if (!hasClass && cartProgressBar === null && hasCollectionPage) {
  if (filterObserverElement) {  
    window.addEventListener("scroll", function() {
      const scrollPosition = (typeof window.scrollY !== 'undefined') ? window.scrollY : window.pageYOffset;
      const path = window.location.pathname;
        
      if (scrollPosition > 400) {
        if (path.includes("search")) {
          headerContainer.style.display = 'none';     
          filterObserverElement.appendChild(tagFilterContainer);          
        }else {
          toggleDivVisibility();
          headerContainer.style.display = 'block';         
        }
      } else {
        headerContainer.style.display = 'none';
        filterObserverElement.appendChild(tagFilterContainer);
      }
    });

    
    // Function to toggle the visibility of the div
    function toggleDivVisibility() {
      if (filterObserverElement.classList.contains("js-observed")){
        return;
      }          
      let variableTest = false;
      const observer1 = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (
            entry.target === filterObserverElement &&
            entry.isIntersecting &&
            headerContainer.contains(headertagFilterContainer)
          ) {
            headertagFilterContainer.remove();
            filterObserverElement.appendChild(tagFilterContainer);
          } else if (
            entry.target === filterObserverElement &&
            !entry.isIntersecting &&
            !headerContainer.contains(headertagFilterContainer)
          ) {
            headerContainer.innerHTML="";           
            headerContainer.appendChild(headertagFilterContainer);
            scrollElementToCenter();
            variableTest = true;
          } else if (
            entry.target === footerObserverElement &&
            entry.isIntersecting &&
            headerContainer.contains(headertagFilterContainer)
          ) {
            headertagFilterContainer.remove();
            filterObserverElement.appendChild(tagFilterContainer);
          } else if (
            entry.target === footerObserverElement &&
            !entry.isIntersecting &&
            !headerContainer.contains(headertagFilterContainer) &&
            variableTest
          ) {
            headerContainer.innerHTML="";           
            headerContainer.appendChild(headertagFilterContainer);
            scrollElementToCenter();
          }
        });
      });
    
      // Start observing both elements
      observer1.observe(filterObserverElement);
      observer1.observe(footerObserverElement);
      filterObserverElement.classList.add("js-observed");
      footerObserverElement.classList.add("js-observed");
    }
  }
  
  const navItems = document.querySelectorAll('.filter-item');
  
  navItems.forEach(function(navItem) {
    navItem.addEventListener('click', function() {
      const targetSection = document.querySelector('.mmc-header__title');
      const offsetTop = targetSection.offsetTop - 235;
  
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth',
      });
    });
  });
  
  function scrollElementToCenter() {
    const selectedElement = document.querySelector(".tab-filter-selected");
    const container = document.querySelector(".filter-content");
    if (selectedElement) {
      const elementOffset = selectedElement.offsetLeft - container.offsetLeft;
      const containerMiddle = container.clientWidth / 2;
      const scrollToMiddle = elementOffset - containerMiddle + selectedElement.clientWidth / 2;
  
      container.scrollTo({
        left: scrollToMiddle,
        behavior: "smooth",
      });
    }
  }
} 

// collection banner click scroll to bottom
document.addEventListener('DOMContentLoaded', () => {
  let collectionBanner = document.querySelector('section div.banner');

  if (collectionBanner) {  
    collectionBanner.addEventListener('click', () => {
        let targetHeading = document.querySelector('.mmc-main .mmc-toolbar');
        let offsetTop = targetHeading .offsetTop - 150;
    
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        });
    })
  }

  // multiple add to cart 
  let hasRun = false;

  const checkAndRun = () => {
    const bannerContainers = document.querySelectorAll('.multi_product_addcart');
    if (bannerContainers.length > 0 && !hasRun) { // Check if there are any banner containers

      bannerContainers.forEach((BannerContainer) => {
        const productIds = BannerContainer.getAttribute('data-product-id');
        const addToCartToggler = BannerContainer.getAttribute('data-add-cart');
    
        if (addToCartToggler === "true") {
          BannerContainer.addEventListener('click', function (event) {
            event.preventDefault();
    
            let variantIdsArr = productIds?.split(',');
    
            let productVariantObjects = [];
            let productVariantIds = [];
    
            function createVariantsObject(variantIds) {
              return variantIds.map((variantId) => ({
                id: variantId,
              }));
            }
    
            const variantObjects = createVariantsObject(variantIdsArr);
            productVariantIds.push(...variantIdsArr);
            productVariantObjects.push(...variantObjects);
    
            let data = { items: [...productVariantObjects] };
            data['sections'] = "cart-drawer,cart-icon-bubble";
            data['sections_url'] = "/cart";
    
            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(data)
            })
              .then((response) =>
                response.json()
              )
              .then((data) => {
                let cartDrawerElement = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    
                if (cartDrawerElement?.classList.contains('is-empty')) {
                  cartDrawerElement?.classList.remove('is-empty');
                }
    
                cartDrawerElement.renderContents(data);
                cartDrawerElement.addFreebie();
              });
          });
        }
      });

      var mySplide = new Splide('.splide-multipleAdd', {
        type: 'loop',
        speed: 500,
        perPage: 1,
        updateOnMove: true,
        pagination: true,
        arrows: true,
        autoplay: true,
        interval: 3000
      });

      mySplide.mount();
      hasRun = true; 
    }
  };
  setInterval(checkAndRun, 1000);
});

// class GlobalOfferPopup extends HTMLElement {
//   constructor() {
//     super();
//     this.init();
//   }

//   init(){
//     document.addEventListener('click', (event) => {
//       // Check if the popup is open
//       const isPopupOpen = this.querySelector('.showGlobal-popup');
      
//       if (isPopupOpen) {
//         // Close the popup if clicked outside of it
//         this.closeGlobalPopup(event);
//       } else {
//         // Continue with your existing click event listener for the popup button and close button
//         if (this.contains(event.target)) {
//           this.handlePopupClick(event);
//         }
//       }
//     });
    
//   }

//   handlePopupClick(event) {
//     const target = event.target;

//    // Check if the clicked element or its ancestor is the global__popupButton
//     if (target.classList.contains('global__popupButton') || target.closest('.global__popupButton')) {
//       this.showGlobalPopup(event);
//     }

//     // Check if the clicked element or its ancestor is the global__popupClose
//     if (target.classList.contains('global__popupClose') || target.closest('.global__popupClose')) {
//       this.closeGlobalPopup(event);
//     }

//   }

//   showGlobalPopup(event) {
//     var globalPopupElement = this.querySelector('.global__popup');
//     var globalPopupCotainerOverlay = this.querySelector('.global__popupCotainerOverlay');
//     globalPopupElement.classList.toggle('showGlobal-popup');
//     globalPopupCotainerOverlay.classList.toggle('overlayDisplay');
//     document.querySelector("body").style.overflow = (document.querySelector("body").style.overflow === "hidden") ? "auto" : "hidden";
//     document.querySelector('.global__popupCotainer').style.zIndex = '999';
//     document.querySelector('.global__popupButton').style.zIndex = '999';
//   }
//   closeGlobalPopup(event){
//     var globalPopupElement = this.querySelector('.global__popup');
//     var globalPopupCotainerOverlay = this.querySelector('.global__popupCotainerOverlay');
//     globalPopupElement.classList.toggle('showGlobal-popup');
//     globalPopupCotainerOverlay.classList.toggle('overlayDisplay');
//     document.querySelector("body").style.overflow = "auto";
//     document.querySelector('.global__popupCotainer').style.zIndex = '996';
//     document.querySelector('.global__popupButton').style.zIndex = '996';
//   };
// }

// customElements.define('global-offer-popup', GlobalOfferPopup);

// card variant buttons
class ScrollButtons extends HTMLElement {
  connectedCallback() {
    this.leftButton = this.querySelector('.left-btn');
    this.rightButton = this.querySelector('.right-btn');
    this.variantsContainer = this.parentElement.querySelector('.variants_container');
    this.variants = Array.from(this.variantsContainer.children);

    this.currentIndex = 0;

    this.leftButton.addEventListener('click', this.scrollToLeft.bind(this));
    this.rightButton.addEventListener('click', this.scrollToRight.bind(this));

    this.updateButtonVisibility();
  }

  scrollToLeft() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      const variantWidth = this.variants[this.currentIndex].offsetWidth;
      this.variantsContainer.scrollBy({
        left: -variantWidth,
        behavior: 'smooth',
      });
    }
    this.updateButtonVisibility();
  }

  scrollToRight() {
    if (this.currentIndex < this.variants.length - 1) {
      const variantWidth = this.variants[this.currentIndex].offsetWidth;
      this.currentIndex++;
      this.variantsContainer.scrollBy({
        left: variantWidth,
        behavior: 'smooth',
      });
    }
    this.updateButtonVisibility();
  }

  updateButtonVisibility() {
    this.leftButton.style.display = this.currentIndex > 0 ? 'flex' : 'none';
    this.rightButton.style.display = this.currentIndex < this.variants.length - 1 ? 'flex' : 'none';
  }
}

customElements.define('scroll-buttons', ScrollButtons);
 
document.addEventListener('DOMContentLoaded', () => {
  const submitButton = document.querySelector('.contact__button-kapture');
  const successMessage = document.querySelector('.contact .form__message');

  submitButton?.addEventListener('click', (event) => {
    event.preventDefault(); // Prevent the default form submission
    const customerName = document.querySelector("#ContactForm-name").value.trim();
    const customerEmail = document.querySelector("#ContactForm-email").value.trim();
    const customerNumber = document.querySelector("#phone-number").value.trim();
    const countryCode = document.querySelector("#country_code").value.trim();
    const customerFullNumber = countryCode + customerNumber;
    const selectedQuery = document.querySelector("#query_form").value.trim();
    const customerMessage = document.querySelector("#ContactForm-body").value.trim();

    // Validate that the required fields are not empty
    if (!customerName || !customerEmail || !customerNumber || !countryCode || !selectedQuery || !customerMessage) {
      alert('All fields are required.');
      return; // Stop the function execution if validation fails
    }

    const url = 'https://Peptech.kapturecrm.com/add-ticket-from-other-source.html/v.2.0';
    const headerss = {
      'Content-Type': 'application/json',
      'Authorization': 'bWF0cWM2eDd1bGhoOW1tenRyZnA4MTl2OHhqM3gxdjJ2OTFxNW41MmZ5emtvcm94ZHY'
    };
    const body = JSON.stringify([
      {
        "title": "Test Web",
        "ticket_details": "",
        "due_date": "2024-06-17",
        "customer_name": customerName,
        "phone": customerFullNumber,
        "email_id": customerEmail,
        "comment": [
          {
            "comment": "Testing"
          }
        ],
        "query": [
          {
            "query": selectedQuery
          }
        ],
        "message": [
          {
            "message": customerMessage
          }
        ]
      }
    ]);

    fetch(url, {
      method: 'POST',
      headers: headerss,
      body: body
    })
    .then(response => response.json())
    .then(data => {
      console.log('Success:', data);
      successMessage.style.display = 'flex'; // Show success message
      document.querySelector("#ContactForm-name").value = '';
      document.querySelector("#ContactForm-email").value = '';
      document.querySelector("#phone-number").value = '';
      document.querySelector("#query_form").value = '';
      document.querySelector("#ContactForm-body").value = '';
    })
    .catch((error) => {
      console.error('Error:', error);
      successMessage.style.display = 'none'; // Hide success message if there's an error
    });
  });
});

class ReadMore extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });

        const container = document.createElement('div');
        container.classList.add('read-more-container');

        const content = document.createElement('div');
        content.classList.add('read-more-content');
        content.innerHTML = this.innerHTML;

        const button = document.createElement('button');
        button.textContent = 'Read More';
        button.classList.add('read-more-button');
        button.addEventListener('click', () => this.toggleReadMore(content, button));

        container.appendChild(content);
        container.appendChild(button);
        this.shadowRoot.append(container);

        // Adding styles
        const style = document.createElement('style');
        style.textContent = `
            .read-more-content.expanded {
                max-height: none;
                -webkit-line-clamp: unset;
            }
            .read-more-button {
                display:block;
                background: transparent;
                border: none;
                color: black;
                padding: 0;
                margin-top: 7px;
                text-decoration: underline;
                text-underline-offset: 2px;
                cursor:pointer;
            }
            .read-more-content p {
              margin:0;
            }
            @media screen and (max-width: 749px) {
              .read-more-button {
                display:block;
              }
              .read-more-content {
               overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
                max-height: 5.5em;
                line-height: 1.5em;
              }
            }
            @media screen and (min-width: 750px) {
              .read-more-button {
                display:none;
              }
              .read-more-content {
                  overflow: hidden;
                  display: -webkit-box;
                  -webkit-line-clamp: 5;
                  -webkit-box-orient: vertical;
                  max-height: 8em;
                  line-height: 1.5em;
              }
            }
        `;
        this.shadowRoot.appendChild(style);
    }

    toggleReadMore(content, button) {
        if (content.classList.contains('expanded')) {
            content.classList.remove('expanded');
            button.textContent = 'Read More';
        } else {
            content.classList.add('expanded');
            button.textContent = 'Read Less';
        }
    }
}

customElements.define('read-more', ReadMore);

// pulse ATC PDP

window.cartButtonPulse = function() {
  const cartButtons = document.querySelectorAll('.mobile-cart-button .atc-button-container .grid');

  cartButtons.forEach((btn) => {
    btn.style.transition = 'transform 0.3s ease-in-out';
  });
  setInterval(() => {
    cartButtons.forEach((btn) => {
      btn.style.transform = 'scale(1.05)';
      
      setTimeout(() => {
        btn.style.transform = 'scale(1)';
      }, 500);
    });
  }, 1000);
};

if (window.location.pathname === '/checkout') {
  window.location.href = '/';
  window.location.replace('/');
}

document.addEventListener("DOMContentLoaded", function() {
  const isPopupShown = sessionStorage.getItem("collection-popup-shown");

  if (isPopupShown === null) {
    const overlay = document.querySelector(".collection-popup-overlay");
    if (overlay) {
      overlay.style.display = "block";
    }
    const closeButton = document.getElementById("close-button");
    if (closeButton) {
      closeButton.addEventListener("click", function() {
        if (overlay) {
          overlay.style.display = "none";
        }
      });
    }

    setTimeout(()=> {
      if (overlay) {
        overlay.style.display = "none";
      }
    }, 3000)

    sessionStorage.setItem("collection-popup-shown", "true");
  }
});

document.addEventListener("DOMContentLoaded", function(){
  const navigationTabList = document.querySelectorAll(".tab-col-link");

  navigationTabList.forEach((navigationTab) => {
    navigationTab.addEventListener("click", (event) => {

      async function fetchCartData() {
        try {
          const response = await fetch("/cart.js");
          const data = await response.json();

          const categoryName = navigationTab.dataset.categoryName;
          const categoryLink = navigationTab.dataset.categoryLink;
          const categoryImage = navigationTab.dataset.categoryImage;
          const cartValue = Math.round(data.total_price / 100);

          dataLayer.push({
            event: "mobile_category_rail",
            Category_Name: categoryName,
            Category_Link: categoryLink,
            Cart_Value: cartValue,
            Category_Image: categoryImage
          });
        } catch (error) {
          console.error("Failed to fetch cart data:", error);
        }
      }

      fetchCartData()
    })
  })
})

class ShadeCollectionFilter extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.handleFilterClick.bind(this));
    this.spinner = document.querySelector(".shades-collection-loader");
    this.productsLoaded = 0;
    this.activeFilter = null;
  }

  async connectedCallback() {
    await this.appendAllProductsToDOM()

    const urlParams = new URLSearchParams(window.location.search);
    const filter = urlParams.get("q") || "type__All";

    this.applyFilter(filter);

    window.addEventListener("scroll", this.handleInfiniteScroll.bind(this));
  }

  async appendAllProductsToDOM(){
    const totalPages = parseInt(document.querySelector('.shades-collection-grid').getAttribute('data-pages'));
    const sectionId = document.querySelector(".shades-collection-grid").getAttribute('data-id');

    const loadMoreProducts = async (pageNumber) => {
      const productGrid = document.getElementById('product-grid');
      if (pageNumber > totalPages) return;

      try {
        const response = await fetch(`${window.location.pathname}?page=${pageNumber}&section_id=${sectionId}`);
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newProducts = doc.querySelectorAll('#product-grid .grid__item');
        newProducts.forEach(product => productGrid.appendChild(product));
      } catch (error) {
        console.error('Error loading products:', error);
      }
    };

    for (let pageNumber = 2; pageNumber <= totalPages; pageNumber++) {
      await loadMoreProducts(pageNumber)
    }

    const productCards = document.querySelectorAll(".product-grid .product-card-wrapper");
  }

  handleFilterClick(event) {
    const target = event.target.closest(".shades-filter__item");

    if (target) {
      this.applyFilter(target.dataset.filter);

      const collectionName = this.getAttribute('data-collection-name');
      const collectionProductCount = this.getAttribute('data-product-count');
      const collectionProductTitle = this.getAttribute('data-product-titles');

      dataLayer.push({
        'event': 'Collection_Filter',
        'Filter_Name': target.textContent,
        'Collection_Name': collectionName,
        'Total_Products': collectionProductCount,
        'Products_Name': collectionProductTitle
      });
    }
  }

  applyFilter(filterValue) {
    this.activeFilter = filterValue;
    this.productsLoaded = 0;

    const url = new URL(window.location);
    url.searchParams.set("q", filterValue);
    window.history.pushState({}, "", url);

    const productCards = document.querySelectorAll(".product-grid .product-card-wrapper");
    productCards.forEach((productCard) => {
      const closestGridItem = productCard.closest("li.grid__item");
      closestGridItem.classList.add("hidden");
    });

    this.loadProducts(filterValue);

    this.updateActiveClass(filterValue);
  }

  loadProducts(filterValue) {
    const productsPerScroll = parseInt(document.querySelector(".shades-collection-grid").getAttribute("data-products-per-scroll"));
    const productCards = Array.from(document.querySelectorAll(".product-grid .product-card-wrapper"));

    const filteredProducts = productCards.filter((productCard) => {
      const tags = productCard.getAttribute("data-tags");
      return tags.includes(filterValue) || filterValue === "type__All";
    });

    if (this.productsLoaded < filteredProducts.length) {
      this.spinner.classList.remove("hidden");
    }

    for (let i = this.productsLoaded; i < this.productsLoaded + productsPerScroll && i < filteredProducts.length; i++) {
      const closestGridItem = filteredProducts[i].closest("li.grid__item");
      closestGridItem.classList.remove("hidden");
    }

    this.productsLoaded += productsPerScroll;
    this.spinner.classList.add("hidden");
  }

  handleInfiniteScroll() {
    const observerHeight = window.innerWidth <= 750 ? 1000 : 550
    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - observerHeight) {
      this.loadProducts(this.activeFilter);
    }
  }

  updateActiveClass(filterValue) {
    this.querySelectorAll(".shades-filter__item").forEach((item) => {
      item.classList.toggle("active", item.dataset.filter === filterValue);
    });
  }
}

customElements.define("shade-collection-filter", ShadeCollectionFilter);

class CustomAccordion extends HTMLElement {
  constructor() {
    super();
    this.customAccordions = this.querySelectorAll(".custom-accordion-header");

    this.customAccordions.forEach(header => {
      header.addEventListener("click", () => {
        const currentContent = header.nextElementSibling;
        const isActive = header.classList.contains("active-custom-accordion");

        this.customAccordions.forEach(otherHeader => {
          const otherContent = otherHeader.nextElementSibling;
          if (otherContent !== currentContent) {
            otherContent.style.maxHeight = "0";
            otherContent.style.display = "none";
            otherHeader.classList.remove("active-custom-accordion");
          }
        });

        if (isActive) {
          currentContent.style.maxHeight = "0";
          setTimeout(() => {
            currentContent.style.display = "none";
          }, 450); 
          header.classList.remove("active-custom-accordion");
        } else {
          currentContent.style.display = "flex";
          const height = currentContent.scrollHeight;
          currentContent.style.maxHeight = height + "px";
          header.classList.add("active-custom-accordion");
        }
      });
    });
  }
}

customElements.define("custom-accordion", CustomAccordion);

class CollectionProgressbar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.updateProgressBar();
    this.lastScrollY = window.scrollY;

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        this.handleIntersection(entry,this.querySelector("#stickyProgressbar"));
      });
    });
    
    this.observer.observe(this);
    this.initialCheck(this.querySelector("stickyProgressbar"));
  }

  updateProgressBar(){
    const goals = this.getAttribute("data-goals");
    const fillBy = 100/(goals-1);
    const tag = this.getAttribute("data-tag");
    const quantityMessage = document.querySelector(".quantity-message-bottom-container")
    const productInCart= quantityMessage ? quantityMessage.dataset[tag] : 0;
    this.querySelector(".progress-bar--filled").style.width=`${fillBy*(productInCart-1) > 100 ? 100 :fillBy*(productInCart-1)<0 ? 0 :fillBy*(productInCart-1)}%`;
    let progressBarGoal = this.querySelectorAll(".collection-progress-bar--goal");

    progressBarGoal.forEach((goal) => {
      goal.classList.remove("filled");
      void goal.offsetWidth; 
    });
    
    for (let i = 0; i < productInCart && i < goals; i++) {
      progressBarGoal[i].classList.add("filled"); 
    }
    
    if (productInCart >= goals && typeof document.querySelector(".drawer").open === "function"){
      document.querySelector(".drawer").open();
    }
  }

  handleIntersection(entry,progressbar) {
    const currentScrollY = window.scrollY;

    if (!entry.isIntersecting && currentScrollY > this.lastScrollY) {
      progressbar.classList.add('sticky-progressbar');
    } else if (currentScrollY <= this.lastScrollY) {
      progressbar.classList.remove('sticky-progressbar');
    }
    this.lastScrollY = currentScrollY;
  }

  initialCheck(progressbar) {
    const rect = this.getBoundingClientRect();

    if (rect.top < 0) {
      progressbar.classList.add('sticky-progressbar');
    } else {
      progressbar.classList.remove('sticky-progressbar');
    }
  }
  disconnectedCallback() {
    this.observer.disconnect();
  }
}

customElements.define("collection-progressbar", CollectionProgressbar);

class OfferBundleText extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback(){
    let offerProductCount = 0;
    let offerProductItems = document.querySelectorAll(".offer-product");
    offerProductItems.forEach((item)=>{
      offerProductCount+=Number(item.getAttribute("data-product-count"));
    })
    
    if(offerProductCount >= Number(this.getAttribute("data-offer_goal"))) {
      this.querySelector(".offer-product--collection-link").classList.add("hidden");
    }
  }
}

customElements.define("offer-bundle-text", OfferBundleText);

class AppDownloadPopup extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('.app-download-popup--button');
    this.button.addEventListener('click', this.addDatalayerEvent.bind(this));
  }

  connectedCallback() {
    this.hasScrolled = false;
    let quantityMessage = document.querySelector("#quantity-message");

    if (sessionStorage.getItem('show_apppop') == null) {
      this.setupScrollListener(quantityMessage);
    }

    this.querySelector(".close-icon").addEventListener("click", () => {
      this.classList.add("inactive");

      if (quantityMessage) {
        setTimeout(() => {
          quantityMessage.classList.remove("hidden");
        }, 800);
      }
      sessionStorage.setItem('show_apppop', 'false');
    });

    if (this.getAttribute("data-current-page") == 'collection' && sessionStorage.getItem('show_apppop') != 'false') {
      setTimeout(() => {
        this.showPopup(quantityMessage);
      }, 15000);
    }
  }

  setupScrollListener(quantityMessage) {
    window.addEventListener('scroll', () => {
      const shopByConcernSection = document.querySelector(".shop-by-concern-section");
      const faqSection = document.querySelector(".related-products");

      if ((shopByConcernSection && this.isInView(shopByConcernSection)) ||
          (faqSection && this.isInView(faqSection))) {
        if (!this.hasScrolled) {
          this.showPopup(quantityMessage);
          this.hasScrolled = true;
        }
      }
    });
  }

  isInView(element) {
    const rect = element.getBoundingClientRect();
    return rect.top >= 0 && rect.top <= window.innerHeight / 2;
  }

  showPopup(quantityMessage) {
    setTimeout(() => {
      this.classList.remove("inactive");
      if (quantityMessage) {
        quantityMessage.classList.add("hidden");
      }
      this.handleOutsideClick(quantityMessage);
    }, 1);
  }

  handleOutsideClick(quantityMessage) {
    document.addEventListener('click', function (event) {
      if (!this.contains(event.target)) {
        this.classList.add("inactive");

        if (quantityMessage) {
          setTimeout(() => {
            quantityMessage.classList.remove("hidden");
          }, 800);
        }
        sessionStorage.setItem('show_apppop', 'false');
      }
    }.bind(this));
  }

  addDatalayerEvent() {
    const cartValue = document.querySelector(".cart-discounted-price").textContent;
    const currentPage = this.dataset.currentPage;
    const headerMessage = this.dataset.headerMessage;
    const description = this.dataset.description;

    const clevertapData = {
      'Current_Page': currentPage,
      'Cart_Value': cartValue,
      'Header_Msg': headerMessage,
      'Popup_Description': description
    }

    dataLayer.push({
      'event': "App_Download_Popup",
      'Current_Page': currentPage,
      'Cart_Value': cartValue,
      'Header_Msg': headerMessage,
      'Popup_Description': description,
      clevertap: clevertapData
    });
  }
}

customElements.define("app-download-popup", AppDownloadPopup);

class CopyCode extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback(){
    let offerCoupons = this.querySelectorAll(".offers-segment-coupon");

    offerCoupons.forEach(coupon=>{
      let coupenCode = coupon.getAttribute("data-coupen-code")
      let copyButton = coupon.querySelector(".offers-segment-coupon--copy");

      copyButton.addEventListener("click",()=>{
        copyButton.querySelector(".offers-segment-coupon--copy-icon").classList.add("hidden");
        copyButton.querySelector(".offers-segment-coupon--copy-text").innerText="copied";
        
        setTimeout(() => {
          copyButton.querySelector(".offers-segment-coupon--copy-icon").classList.remove("hidden");
          copyButton.querySelector(".offers-segment-coupon--copy-text").innerText="copy";
        }, 2000);
        navigator.clipboard.writeText(coupenCode).then(() => {
      }).catch(err => {
          console.error("Failed to copy text: ", err);
      });
      })
    })
  }
}

customElements.define("copy-code", CopyCode);

class CustomerForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback(){
    this.querySelector(".customer-form--submit-button").addEventListener("click",()=>{
      this.querySelector(".customer-form--error-message").classList.add("hidden");
      const customerData = this.getFormData();
      this.validateForm(customerData);
    })
    this.querySelector("#customerPhone").addEventListener('input', function(event) {
      let phoneValue = event.target.value;
    
      if (phoneValue.startsWith('0')) {
        phoneValue = phoneValue.substr(1);
      }
    
      phoneValue = phoneValue.replace(/\D/g, '');
    
      if (phoneValue.length > 10) {
        phoneValue = phoneValue.substr(0, 10);
      }
    
      event.target.value = phoneValue;
    });
     
  }

  getFormData(){
    const customerData = {
      'Name': this.querySelector("#customerName").value || '',
      'Email': this.querySelector("#customerEmail").value  || '',
      'Phone Number': this.querySelector("#customerPhone").value || ''
    };

    return customerData;
  }

  validateForm(customerData){
    const errorMessage = this.querySelector(".customer-form--error-message");
    if (Object.values(customerData).some(value => value === '')) {
      errorMessage.innerText="Please fill all the input fields"
      errorMessage.classList.remove("hidden");
      setTimeout(() => {
        errorMessage.classList.add("hidden");
      }, 4000);
    } else if (!(customerData.Email.includes('@') && customerData.Email.includes('.com'))) {
      errorMessage.innerText="Please Enter a valid email id"
      errorMessage.classList.remove("hidden");
      setTimeout(() => {
        errorMessage.classList.add("hidden");
      }, 4000);
    } else {
      this.submitCustomerForm(customerData);
      sessionStorage.setItem('customerForm', 'true');
      window.location.href = '/'; 
    } 
  }

  async submitCustomerForm(customerData){
    try {
      const formData = new FormData();
  
      Object.entries(customerData).forEach(([key, value]) => {
        formData.append(key, value);
      });
  
      const response = await fetch('https://script.google.com/macros/s/AKfycbw8aZLgib4WqRqERIe4ty2lLJMsjDo-wnAwUEDrq4iIUZbOnPV-KT1JaL72WgOz9VO1kg/exec',
        {
          method: 'POST',
          body: formData,
        }
      );
  
      if (response.ok) {
        // console.log("Form submitted successfully");
      } else {
        console.error('Failed to submit the form. Please try again.');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  }
}

customElements.define("customer-form", CustomerForm);

class customerFormMessage extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback(){
    if(sessionStorage.getItem('customerForm') === 'true'){
      this.classList.remove("inactive");
      sessionStorage.setItem('customerForm', 'false');
      setTimeout(() => {
        this.classList.add("inactive");
      }, 4000);
    }
  }
}

customElements.define("customer-form-message", customerFormMessage);

class BogoPopup extends HTMLElement {
  constructor() {
    super();
    this.mobileNumberElement = this.querySelector('.bogo-popup__content-wrapper input');
    this.overlayContainer = this.querySelector(".bogo-popup__overlay-container");
    this.contentWrapper = this.querySelector(".bogo-popup__content-wrapper");
    this.navigationButton = this.querySelector(".bogo-popup__buttons-wrapper a");
    this.closePopupButton = this.querySelector(".bogo-popup__close-button");
    this.closePopupTextButton = this.querySelector(".bogo-popup__buttons-wrapper button");

    if (this.getAttribute("data-enable-input") == 'true') {
      this.mobileNumberElement.addEventListener('input', this.validateMobileNumber.bind(this));
      this.navigationButton.addEventListener('click', this.sendDataToGoogleSheet.bind(this));
    }

    this.overlayContainer.addEventListener('click', this.handleOverlayClick.bind(this));
    this.closePopupButton.addEventListener('click', this.closeBogoPopup.bind(this));
    this.closePopupTextButton.addEventListener('click', this.closeBogoPopup.bind(this));
  }

  connectedCallback() {
    const isBogoPopupDisplayed = sessionStorage.getItem("bogo-popup-shown");
    const delayTime = parseInt(this.dataset.popupDelayTime) * 1000;
    const displayTime = (parseInt(this.dataset.popupDisplayTime) * 1000) + delayTime;

    if (isBogoPopupDisplayed === null || isBogoPopupDisplayed === false) {
      setTimeout(() => {
        this.classList.remove("hide-bogo-popup");
        this.submitDatalayerEvents(this);
      }, delayTime);


      this.timerId = setTimeout(() => {
        this.classList.add("hide-bogo-popup");
        sessionStorage.setItem('bogo-popup-shown', true);
      }, displayTime)
    }

    if (this.getAttribute("data-enable-input") == 'true') {
      this.navigationButton.classList.add('disabled');
      this.navigationButton.style.pointerEvents = "none";
    }
  }

  handleOverlayClick(event) {
    if (!this.contentWrapper.contains(event.target)) {
      this.closeBogoPopup();
    }
  }

  closeBogoPopup() {
    this.overlayContainer.classList.add('hide-bogo-popup');
    sessionStorage.setItem('bogo-popup-shown', true);

    const clevertapData = {
      'Landing_Page': this.getAttribute("data-button-url") || '',
      'Current_Page': this.getAttribute("data-current-page") || '',
      'Cart_Value': document.querySelector(".cart-discounted-price").textContent || '',
      'Button_Text' : this.getAttribute("data-button") || ''
    }

    dataLayer.push({
      'event': "Popup_Cta_Close",
      'Landing_Page': this.getAttribute("data-button-url") || '',
      'Current_Page': this.getAttribute("data-current-page") || '',
      'Cart_Value': document.querySelector(".cart-discounted-price").textContent || '',
      'Button_Text' : this.getAttribute("data-button") || '',
      clevertap: clevertapData 
    });

  }

  validateMobileNumber() {
    clearTimeout(this.timerId)
    const mobileNumber = this.mobileNumberElement.value;
    const errorMessage = this.querySelector('.bogo-popup__error-message');
  
    if (mobileNumber.length === 10 && /^\d{10}$/.test(mobileNumber)) {
      this.navigationButton.classList.remove('disabled');
      this.navigationButton.style.pointerEvents = "auto";
      if (errorMessage) errorMessage.textContent = "";
    } else {
      this.navigationButton.classList.add('disabled');
      this.navigationButton.style.pointerEvents = "none";
  
      if (mobileNumber.length > 0) {
        if (mobileNumber.length < 10) {
          errorMessage.textContent = "*Number must be 10 digits.";
        } else if (mobileNumber.length > 10) {
          errorMessage.textContent = "*Number cannot exceed 10 digits.";
        }
      }
    }
  }
  

  sendDataToGoogleSheet() {

    const clevertapData = {
      'Landing_Page': this.getAttribute("data-button-url") || '',
      'Current_Page': this.getAttribute("data-current-page") || '',
      'Cart_Value': document.querySelector(".cart-discounted-price").textContent || '',
      'Button_Text' : this.getAttribute("data-button") || ''
    }

    dataLayer.push({
      'event': "Popup_Cta_Clicked",
      'Landing_Page': this.getAttribute("data-button-url") || '',
      'Current_Page': this.getAttribute("data-current-page") || '',
      'Cart_Value': document.querySelector(".cart-discounted-price").textContent || '',
      'Button_Text' : this.getAttribute("data-button") || '',
      clevertap: clevertapData 
    });

    const mobileNumber = this.mobileNumberElement.value;
    const url = "https://script.google.com/macros/s/AKfycbz0NpRYMqgjMdipnvNGVUzHs1XVDXG5gpMntIKrxy2BeHSn190CD8Ik66xrikJuiKx98Q/exec"
    const formData = new FormData();
    formData.append('Mobile Number', mobileNumber);

    try {
      fetch(url, {
        method: 'POST',
        body: formData
      })
    } 
    catch (error) {
      console.error('Error sending data:', error);
    }
  }

  submitDatalayerEvents(popup) {

    const clevertapData = {
      'Image': popup.getAttribute("data-image") || '',
      'Header_Communication': popup.getAttribute("data-title") || '',
      'Subtext_communication': popup.getAttribute("data-sub-text")  || '',
      'Button_Text' : popup.getAttribute("data-button") || ''
    }

    dataLayer.push({
      'event': "Offer_Popup",
      'Image': popup.getAttribute("data-image") || '',
      'Header_Communication': popup.getAttribute("data-title") || '',
      'Subtext_communication': popup.getAttribute("data-sub-text") || '',
      'Button_Text' : popup.getAttribute("data-button") || '',
      clevertap: clevertapData 
    });
  }

}

customElements.define('bogo-popup', BogoPopup);


class NotifyMeForm extends HTMLElement {

  connectedCallback() {
    const form = this.querySelector('#googleForm');
    const submitButton = form.querySelector('button[type="submit"]');

    this.submitForm = this.submitForm.bind(this);

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      this.submitDatalayerEvents();
      const emailField = this.querySelector('#googleEmail');

      if (emailField && emailField.value.trim() !== "") {
        submitButton.disabled = true;

        const formData = new FormData(form);
        const productId = formData.get('Product ID');
        let submittedProductIds = JSON.parse(localStorage.getItem('submittedProductIds')) || [];

        if (submittedProductIds.includes(productId)) {
          this.showSuccessMessage();
          setTimeout(() => {
            submitButton.disabled = false;
          }, 4000);
          return;
        }

        await this.submitForm(formData, productId, form, submitButton);
      }
    });
  }

  async submitForm(formData, productId, form, submitButton) {

    try {
      let submittedProductIds = JSON.parse(localStorage.getItem('submittedProductIds')) || [];

      if (!submittedProductIds.includes(productId)) {
        const response = await fetch('https://script.google.com/macros/s/AKfycbyppjMZ66J5fJsu-cNJVp_hF7P4-NkjhrkQXrA6wNFHtmhlEGuHy3keZ30eSQyVqv9J/exec', {
          method: 'POST',
          body: formData,
        });

        if (response.ok) {
          submittedProductIds.push(productId);
          localStorage.setItem('submittedProductIds', JSON.stringify(submittedProductIds));

          form.reset();
          this.showSuccessMessage();
        } else {
          console.log('Failed to submit the form. Please try again.');
        }
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      submitButton.disabled = false;
    }
  }

  showSuccessMessage() {
    const successMessage = document.querySelector('.notify-me-success-message-popup');
    successMessage.classList.remove("inactive");

    setTimeout(() => {
      successMessage.classList.add("inactive");
    }, 3500);
  }

  submitDatalayerEvents() {
    let clevertapData = {
      Product_Id : this.querySelector("#googleProductId").value || '',
      Product_SKU : this.querySelector("#googleSkuId").value || '',
      MRP : this.getAttribute("data-price") || '',
      Offer_Price : this.getAttribute("data-offer-price") || '',
    }

    dataLayer.push({
      event: "Notify_Me",
      Product_Id : this.querySelector("#googleProductId").value || '',
      Product_SKU : this.querySelector("#googleSkuId").value || '',
      MRP : this.getAttribute("data-price") || '',
      Offer_Price : this.getAttribute("data-offer-price") || '',
      clevertap : clevertapData
    });
  }
}

customElements.define('notify-me-form', NotifyMeForm);

class RenderNotifymeForm extends HTMLElement {
  constructor() {
    super();
  }
  
  connectedCallback(){
    const notifyMeForm = document.querySelector("notify-me-form");
  
    if (notifyMeForm) {
      this.innerHTML = "";
      const clonedForm = notifyMeForm.cloneNode(true);
      const formData = this.dataset;
  
      clonedForm.querySelector("#googleProductTitle").value = formData.productTitle || "";
      clonedForm.querySelector("#googleProductId").value = formData.productId || "";
      clonedForm.querySelector("#googleVariantId").value = formData.variantId || "";
      clonedForm.querySelector("#googleSkuId").value = formData.skuId || "";
  
      this.appendChild(clonedForm);
    }
  }
}

customElements.define('render-notifyme-form', RenderNotifymeForm);

function saveFormDataToLocalStorage(event) {
  const notifyMeFormElement = event.target.closest("notify-me-form");
  const notifyMeForm = notifyMeFormElement.querySelector("#googleForm");
  const formData = new FormData(notifyMeForm);
  const formDataObject = {};

  formData.forEach((value, key) => {
    formDataObject[key] = value;
  });

  const notifyMeFormState = {
    submitNotifyMeForm: true,
    formData: formDataObject
  };

  localStorage.setItem('NotifyMeForm', JSON.stringify(notifyMeFormState));
}
class LeaderBoardBanner extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback(){
    this.leaderBoardBanner = this.querySelectorAll(".leaderboard-image-container a");

    this.leaderBoardBanner.forEach((banner)=>{
      banner.addEventListener("click",()=>{
        let clevertapData = {
          Section_Title: this.getAttribute("data-section-title") || "",
          Block_title : banner.getAttribute("data-block-title") || "", 
          Image : banner.querySelector("img").src,
          landing_Link : banner.href || "",
          Cart_Value : document.querySelector(".cart-discounted-price").textContent || ''
        }
    
        dataLayer.push({
          event: "HP_Banner",
          Section_Title: this.getAttribute("data-section-title") || "",
          Block_title : banner.getAttribute("data-block-title") || "", 
          Image : banner.querySelector("img").src,
          landing_Link : banner.href || "",
          Cart_Value : document.querySelector(".cart-discounted-price").textContent || '',
          clevertap : clevertapData
        });
      })
    })
  }
}

customElements.define('leader-board-banner', LeaderBoardBanner);
class CategoryTab extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback(){
    let tabButtons = this.querySelectorAll(".category-tab-content-tab-button");

    tabButtons.forEach((button) => {
      button.addEventListener("click",()=>{
        this.switchContent(button);
      })
    });
  }

  switchContent(button){
    let index = button.getAttribute("data-index");
    let prevActiveButton = this.querySelector(".active-tab-button")
    let prevActiveContent = this.querySelector(".show-content");
    let presentActiveContent = this.querySelector(`.category-tab-content-${index}`);

    this.addDataLayerEvent(button,presentActiveContent);

    prevActiveContent.classList.remove("show-content");
    setTimeout(() => {
      prevActiveContent.closest(".category-tab-content-wrapper").classList.add("hidden");
      presentActiveContent.closest(".category-tab-content-wrapper").classList.remove("hidden");
    }, 400);
    setTimeout(() => {
      presentActiveContent.classList.add("show-content");
    }, 500);
    prevActiveButton.classList.remove("active-tab-button");
    button.classList.add("active-tab-button");

    const tabButtonWrapper = this.querySelector(".category-tab-content--tabs");

    if (tabButtonWrapper) {
      const tabButton = button.getBoundingClientRect();
      const tabButtonWrapperRect = tabButtonWrapper.getBoundingClientRect();
  
      tabButtonWrapper.scrollBy({
          left: tabButton.left - tabButtonWrapperRect.left - (tabButtonWrapper.clientWidth / 2) + (tabButton.width / 2),
          behavior: "smooth"
      });
    }
  }

  addDataLayerEvent(button,content){
    let leftBannerImg = "";
    if(content.querySelector(".category-tab-content--image-wrapper img")){
      leftBannerImg = content.querySelector(".category-tab-content--image-wrapper img").src;
    }
    let categoryLink = button.getAttribute("data-collection-link");
    let producCards=content.querySelectorAll(".card-wrapper");
    let productsName = [];

    producCards.forEach((card)=>{
      productsName.push(card.querySelector(".card__heading a.full-unstyled-link").innerText.trim());
    })

    let clevertapData = {
      Category_Name: button.innerText,
      Category_Link :categoryLink, 
      Left_Banner_Img : leftBannerImg,
      Products_Name : productsName.join(","),
    }

    dataLayer.push({
      event: "Category_tab",
      Category_Name: button.innerText,
      Category_Link :categoryLink, 
      Left_Banner_Img : leftBannerImg,
      Products_Name : productsName.join(","),
      clevertap : clevertapData
    });
  }
}

customElements.define('category-tab', CategoryTab);

class BundleAtc extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback(){
    this.atcButton = this.querySelector(".bundle-atc-button");
    this.errorMessage = this.querySelector(".bundle-atc-error")
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    this.atcButton.addEventListener("click",()=>{
      this.errorMessage.classList.add('hidden');
      let selectedBundle = this.querySelector("input[name='bundle']:checked");

       if (selectedBundle) {
        let unit = selectedBundle.getAttribute("data-unit");
        let variantId = selectedBundle.getAttribute("data-variant-id");
        this.addBundleProduct(unit,variantId);
       } else if (this.errorMessage) {
        this.errorMessage.classList.remove('hidden');
        setTimeout(() => {
          this.errorMessage.classList.add('hidden');
        }, 5000);
       }
    })
  }

  addBundleProduct(unit,variantId) {  
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';

    const bundleProducts = {"items": [{'id': variantId, 'quantity': unit}]};

    if (this.cart) {
      bundleProducts['sections'] = this.cart.getSectionsToRender().map((section) => section.id);
      bundleProducts['sections_url'] = window.location.pathname;
      this.cart.setActiveElement(document.activeElement);
    }

    config.body = JSON.stringify(bundleProducts);

    fetch('/cart/add.js', config)
    .then(response => response.json())
    .then(data => {
      this.cart.renderContents(data, this.showCart);
      this.cart.addFreebie();
      this.cart.open();
    })
    .catch((error) => {
      console.error('Error:', error);
    })
    .finally(() => {
      if (this.cart && this.cart.classList.contains("is-empty")){
        this.cart.classList.remove("is-empty");
      }
    });
  }
}

customElements.define("bundle-atc" , BundleAtc);

document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.before-after-effect .container');
  if (container) {
    document.querySelector('.before-after-effect .ba-slider').addEventListener('input', (e) => {
      container.style.setProperty('--position', `${e.target.value}%`);
    })
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const detailsElements = document.querySelectorAll(".faq-container details");
  if (detailsElements) {
    detailsElements.forEach((details) => {
      details.addEventListener("toggle", function () {
        if (this.open) {
          detailsElements.forEach((otherDetails) => {
            if (otherDetails !== this) {
                otherDetails.open = false;
            }
          });
        }
      });
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const detailsElements = document.querySelectorAll(".pdp-content-nav-mobile__details");
  if (detailsElements) {
    detailsElements.forEach((details) => {
      details.addEventListener("toggle", function () {
        if (this.open) {
          detailsElements.forEach((otherDetails) => {
            if (otherDetails !== this) {
                otherDetails.open = false;
            }
          });
        }
      });
    });
  }
});
class ProductCardReviews extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback(){
    let ratingCount = Math.round(this.getAttribute('data-score') * 10) / 10;
    this.innerHTML = ratingCount + '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" style="fill: #0009;transform: ;msFilter:;vertical-align: -1.5;"><path d="M21.947 9.179a1.001 1.001 0 0 0-.868-.676l-5.701-.453-2.467-5.461a.998.998 0 0 0-1.822-.001L8.622 8.05l-5.701.453a1 1 0 0 0-.619 1.713l4.213 4.107-1.49 6.452a1 1 0 0 0 1.53 1.057L12 18.202l5.445 3.63a1.001 1.001 0 0 0 1.517-1.106l-1.829-6.4 4.536-4.082c.297-.268.406-.686.278-1.065z"></path></svg>';
  }
}

customElements.define("product-card-reviews" , ProductCardReviews);

document.addEventListener("DOMContentLoaded", function () {
  const cartMobileNav = document.querySelector(".mobile-bottom-nav-cart");
  if (cartMobileNav) {
    cartMobileNav.addEventListener("click",(event)=>{
      event.preventDefault();
      if (typeof document.querySelector(".drawer").open === "function"){
        document.querySelector(".drawer").open();
      }
    })
  }
});

class CartDrawerCouponCode extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      closeButton: ".coupon-code--close-button",
      applyButton: ".coupon-code--apply-button",
      input: ".coupon-code--input",
      inputError: ".coupon-code--input-error-message",
      codeButtons: ".coupon-code--button",
      activeCoupons: ".coupon-code--active-coupons",
      drawerCouponView: ".cart-drawer-coupon-view",
      drawerAppliedCoupon: ".coupon-view-applied-coupon",
      removeButton: ".coupon-code--remove-button",
      cartTotal: ".totals__subtotal-value",
      cartTotalWrapper: ".cart-drawer__footer .totals",
      loader: ".cart-drawer .coupon-code-loader",
      success: ".cart-drawer .coupon-code-success",
      error: ".cart-drawer .coupon-code-error",
      savingStrip : ".cart-drawer__drawer-footer-wrapper .savings-strip",
      discountSavingStrip  : ".cart-drawer__drawer-footer-wrapper .discount-savings-strip"
    };
  }

  connectedCallback() {
    this.initilizeSelectors();
    this.addEventListeners();
    this.checkExistingCoupon();
  }

  initilizeSelectors() {
    this.closeButton = this.querySelector(this.selectors.closeButton);
    this.applyButton = this.querySelector(this.selectors.applyButton);
    this.input = this.querySelector(this.selectors.input);
    this.inputError = this.querySelector(this.selectors.inputError);
    this.codeButtons = this.querySelectorAll(this.selectors.codeButtons);
    this.appliedCoupons = this.querySelector(this.selectors.activeCoupons);
    this.drawerCouponView = document.querySelector(this.selectors.drawerCouponView);
    this.drawerAppliedCoupon = document.querySelector(this.selectors.drawerAppliedCoupon);
    this.cartTotal = document.querySelector(this.selectors.cartTotal);
    this.cartTotalWrapper = document.querySelector(this.selectors.cartTotalWrapper);
    this.couponLoader = document.querySelector(this.selectors.loader);
    this.couponSuccess = document.querySelector(this.selectors.success);
    this.couponError = document.querySelector(this.selectors.error);
    this.savedStrip = document.querySelector(this.selectors.savingStrip);
    this.discountSavingdStrip = document.querySelector(this.selectors.discountSavingStrip);

  }

  addEventListeners() {
    this.closeButton?.addEventListener("click", () => {
      document.querySelector(".coupon-code-wrapper")?.classList.add("hidden");
      document.querySelector(".drawer__header")?.classList.remove("hidden");
      document.querySelector(".drawer__inner")?.classList.remove("prevent-scroll");
    });

    this.applyButton?.addEventListener("click", async () => {
      const code = this.input?.value.trim();
      const isValid = /^[a-zA-Z0-9-_]+$/.test(code);

      if (!isValid) {
        this.inputError?.classList.remove("hidden");
        setTimeout(() => this.inputError?.classList.add("hidden"), 3000);
      } else {
        await this.applyCouponDiscount(code);
      }
      this.input.value = "";
    });

    this.codeButtons.forEach(button => {
      if (!button.hasAttribute("disabled")) {
        button.addEventListener("click", () => {
          const code = button.getAttribute("data-coupon-code");
          if (code){
            button.setAttribute("disabled",'');
            setTimeout(() => {
              button.removeAttribute("disabled");
            }, 1000);
            this.applyCouponDiscount(code);
          } 
        });
      }
    });
  }

  async checkExistingCoupon() {
    const cookieValue = document.cookie.split('; ').find(row => row.startsWith('coupon_applied='));
    const appliedCouponCode = cookieValue?.split('=')[1];
    if (appliedCouponCode && this.getAttribute("data-autoaply-coupon")=='true') {
      const  applyButtons = document.querySelectorAll(".coupon-code--apply-button");
      const spinnerHTML = `<svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                            <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                           </svg>`;

      applyButtons.forEach((item)=>{
        item.innerHTML=spinnerHTML
        item.setAttribute("disabled","");
      });
      document.querySelector(".coupon-code--viewAll")?.setAttribute("disabled",'');

      await this.applyCouponDiscount(appliedCouponCode, false);

      document.querySelector(".coupon-code--viewAll")?.removeAttribute("disabled");

      applyButtons.forEach((item)=>{
        item.innerHTML=`Apply`
        item.removeAttribute("disabled");
      });
    }
  }

  removeCouponDiscount(couponCode) {
    this.appliedCoupons.innerHTML = "";
    this.cartTotal?.classList.remove("hidden");
    this.discountSavingdStrip?.classList.add("hidden")
    this.savedStrip?.classList.remove("hidden");
    document.cookie = "coupon_applied=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax;";

    const couponBtn = this.querySelector(`.coupon-code--button[data-coupon-code="${couponCode}"]`);
    if (couponBtn) {
      couponBtn.removeAttribute("disabled");
      couponBtn.innerText = "Apply";
    }

    this.drawerCouponView?.classList.remove("hidden");
    this.drawerAppliedCoupon?.classList.add("hidden");
    this.drawerAppliedCoupon?.querySelector(this.selectors.removeButton)?.setAttribute("data-coupon-code", "");

    document.querySelector(".cart-drawer__footer .totals__subtotal-value-discounted")?.remove();
    document.querySelectorAll(".cart-item .product_discounted_price").forEach(item => item.remove());
    document.querySelectorAll(".cart-item .quantity__price__wrapper").forEach(item => item.classList.remove("hidden"));
  }

  showAppliedCoupons(couponCode) {
    const coupon = document.createElement("div");
    coupon.classList.add("coupon-applied");
    coupon.innerHTML = `
      <span>
        <svg width="20" height="20" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="#000000">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M13.2 2H8.017l-.353.146L1 8.81v.707L6.183 14.7h.707l2.215-2.215A4.48 4.48 0 0 0 15.65 9c.027-.166.044-.332.051-.5a4.505 4.505 0 0 0-2-3.74V2.5l-.5-.5zm-.5 2.259A4.504 4.504 0 0 0 11.2 4a.5.5 0 1 0 0 1 3.5 3.5 0 0 1 1.5.338v2.138L8.775 11.4a.506.506 0 0 0-.217.217l-2.022 2.022-4.475-4.476L8.224 3H12.7v1.259zm1 1.792a3.5 3.5 0 0 1 1 2.449 3.438 3.438 0 0 1-.051.5 3.487 3.487 0 0 1-4.793 2.735l3.698-3.698.146-.354V6.051z"></path>
        </svg>      
      </span>
      <div>${couponCode}</div>
      <div class="coupon-code--remove-button" data-code="${couponCode}">
        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close" fill="none" viewBox="0 0 18 17">
          <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">
          </path>
        </svg>
      </div>`;

    this.appliedCoupons.appendChild(coupon);
    const removeBtn = coupon.querySelector(this.selectors.removeButton);
    removeBtn?.addEventListener("click", () => this.removeCouponDiscount(couponCode));

    this.drawerCouponView?.classList.add("hidden");
    this.drawerAppliedCoupon.querySelector(".coupon-applied-text").innerText = `${couponCode} applied`;
    this.drawerAppliedCoupon.querySelector(this.selectors.removeButton).setAttribute("data-coupon-code", couponCode);
    this.drawerAppliedCoupon.classList.remove("hidden");
  }

  async applyCouponDiscount(couponCode, showPostEffect = true) {
    const customerId = window.getCustomerId?.();
    if (!customerId || !couponCode) {
      document.cookie = `coupon_applied=${couponCode}; expires=Fri, 31 Dec 9999 23:59:59 GMT;path=/;SameSite=Lax;`;
      return kpHandleLogin(window.location.href);
    } 

    const response = await fetch('/cart.js');
    const cartJson = await response.json();

    if (showPostEffect) this.couponLoader?.classList.remove("hidden");

    const prevCoupon = this.drawerAppliedCoupon?.querySelector(this.selectors.removeButton)?.getAttribute("data-coupon-code");

    const data = {
      cart: cartJson,
      store: Shopify.shop,
      discount: couponCode,
      customer_id: customerId
    };

    try {
      const res = await fetch('https://cartdiscount.mcaffeine.com/discount', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });

      if (!res.ok) {
        throw("coupon can't be applied");
      }

      if (prevCoupon) this.removeCouponDiscount(prevCoupon);
      const result = await res.json();
      document.cookie = `coupon_applied=${couponCode}; expires=Fri, 31 Dec 9999 23:59:59 GMT;path=/;SameSite=Lax;`;
      const { total_price, final_total_price, discount_amount } = result.data.response.formatted_text;

      this.showAppliedCoupons(couponCode);
      this.cartTotal?.classList.add("hidden");
      this.addDataLayerEvents(couponCode,discount_amount);

      //updating cart line item price
      const lineItemDiscount = result?.data?.response?.line_item_discount;

      if (lineItemDiscount && typeof lineItemDiscount === 'object') {
        for (const [id, item] of Object.entries(lineItemDiscount)){
          const lineItemPriceWrapper = document.querySelector(`.cart-item[data-cartProduct-id="${id}"] .cart-item__quantity-wrapper`);

          if (lineItemPriceWrapper && item.discounts.length > 0 ) {

            lineItemPriceWrapper.querySelector(".quantity__price__wrapper")?.classList.add("hidden");
            lineItemPriceWrapper.querySelector(".product_discounted_price")?.remove();
            const lineItemDiscountPrice = document.createElement("div");
            lineItemDiscountPrice.classList.add("product-option", "product_price", "product_discounted_price");
            const originalPrice = item.discounts?.[0]?.original_price;
            const hasDiscount = originalPrice > item.discounted_price;

            lineItemDiscountPrice.innerHTML = `
              <span>Rs. ${item.discounted_price}</span>
              ${hasDiscount ? `<span class="money compare-at-price">Rs. ${originalPrice}</span>` : ''}
            `;
            lineItemPriceWrapper.appendChild(lineItemDiscountPrice);
          };
        };
      } 

      //update total price
      const newTotal = document.createElement("div");
      newTotal.classList.add("totals__subtotal-value-discounted");
      newTotal.innerHTML = `
        <span class="cart-discounted-price">Rs. ${Math.floor(final_total_price * 10)/10}</span>
        <span class="cart-original-price">Rs. ${Math.floor(total_price * 10) / 10}</span>`;
      this.cartTotalWrapper?.appendChild(newTotal);
      
      //update saving strip
      this.discountSavingdStrip.innerText = `You have saved Rs. ${discount_amount}`;
      this.discountSavingdStrip.classList.remove("hidden");
      this.savedStrip?.classList.add("hidden");

      if (showPostEffect) {
        this.couponLoader?.classList.add("hidden");
        this.couponSuccess?.classList.remove("hidden");
        this.couponSuccess?.classList.add("active");
        window.confettiShooter?.();

        setTimeout(() => this.couponSuccess?.classList.remove("active"), 3000);
        setTimeout(() => this.couponSuccess?.classList.add("hidden"), 3800);
      }

      const btn = this.querySelector(`.coupon-code--button[data-coupon-code="${couponCode}"]`);
      if (btn) {
        btn.innerText = "Applied";
        btn.setAttribute("disabled", "");
      }

    } catch (err) {
      console.error("Coupon apply failed:", err);
      if (showPostEffect) {
        this.couponLoader?.classList.add("hidden");
        this.couponError?.classList.remove("hidden");
        this.couponError?.classList.add("active");
        setTimeout(() => this.couponError?.classList.remove("active"), 3000);
        setTimeout(() => this.couponError?.classList.add("hidden"), 3800);
      }
    }
  }

  addDataLayerEvents(couponCode,discountAmount) {
    let description = this.querySelector(`.coupon-code--button[data-coupon-code='${couponCode}']`)?.getAttribute("data-coupon-title");
    let clevertapData = {
      Coupon_Name: couponCode,
      Description: description?description:"", 
      Value : discountAmount,
    }

    dataLayer.push({
      event: "Cart_Coupon",
      Coupon_Name: couponCode,
      Description: description?description:"", 
      Value : discountAmount,
      clevertap : clevertapData
    });
  }
}

customElements.define("cart-drawer-coupon-code", CartDrawerCouponCode);


class CartDrawerCouponView extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initElements();
    this.initEventListeners();
  }

  initElements() {
    this.couponWidget = document.querySelector("cart-drawer-coupon-code");
    this.drawerCouponRemove = this.querySelector(".coupon-code--remove-button");
    this.couponWrapper = document.querySelector(".coupon-code-wrapper");
    this.drawerHeader = document.querySelector(".drawer__header");
    this.drawerInner = document.querySelector(".drawer__inner");
    this.viewAllButton = document.querySelector(".coupon-code--viewAll");
    this.applyButton = this.querySelector(".coupon-code--apply-button");
    this.codeInputEl = this.querySelector(".coupon-code--input");
  }

  initEventListeners() {
    this.viewAllButton?.addEventListener("click", () => {
      this.couponWrapper?.classList.remove("hidden");
      this.drawerHeader?.classList.add("hidden");
      this.drawerInner?.classList.add("prevent-scroll");
      document.querySelector(".drawer__inner ")?.scrollTo({
        top: 0,
      });
    });

    this.applyButton?.addEventListener("click", async() => {
      const couponCode = this.codeInputEl?.value?.trim();
      this.applyButton.setAttribute("disabled", "");

      const containsWhitespace = /\s/.test(couponCode);
      const containsSpecialChars = /[^a-zA-Z0-9-_]/.test(couponCode);

      if (containsWhitespace || containsSpecialChars) {
        this.inputError = this.querySelector(".coupon-code--input-error-message");
        this.inputError.classList.remove("hidden");
        setTimeout(() => {
          this.inputError.classList.add("hidden");
        }, 3000);
      } else if (couponCode && this.couponWidget) {
        await this.couponWidget.applyCouponDiscount(couponCode);
      }
      this.codeInputEl.value = "";
      this.applyButton.removeAttribute("disabled");
    });

    this.drawerCouponRemove?.addEventListener("click", () => {
      const couponCode = this.drawerCouponRemove.getAttribute("data-coupon-code");

      if (couponCode && this.couponWidget) {
        this.couponWidget.removeCouponDiscount(couponCode);
      }
    });
  }
}

customElements.define("cart-drawer-coupon-view", CartDrawerCouponView);

document.addEventListener("DOMContentLoaded", function(){
  const searchInputEl = document.querySelector("#st-search-box") || document.querySelector("#st-search");

  function addEventOnClickOfResults(searchInput){
    const searchResultWrapper = document.querySelector("#st-after-search");

    if (searchResultWrapper) {
      searchResultWrapper.addEventListener('click', function(){
        const clevertapData = {
          Search_Query: searchInput
        }
  
        dataLayer.push({
          event: "Search",
          Search_Query: searchInput,
          clevertap : clevertapData
        });
      })
    }
  }

  if (searchInputEl) {
    searchInputEl.addEventListener('keyup', (event) => {
      if (event.target.value !== "" && event.key === "Enter") {
        const clevertapData = {
          Search_Query: event.target.value
        }

        dataLayer.push({
          event: "Search",
          Search_Query: event.target.value,
          clevertap : clevertapData
        });
      }
    })

    searchInputEl.addEventListener('blur', (event) => {
      if (event.target.value !== "") {
        addEventOnClickOfResults(event.target.value);
      }
    })
  }
})

document.addEventListener("DOMContentLoaded", () => {
  const orderPopupButtons = document.querySelectorAll(".order_details-popup-btn");
  const orderDetailsPopup = document.querySelector(".order_details-popup");
  const orderDetails = orderDetailsPopup?.querySelector(".order_details-details");
  const closeButton = orderDetails?.querySelector(".order_details-close");
  const loader = orderDetails?.querySelector(".order_details-loader");
  const body = document.body;

  if (!orderPopupButtons.length || !orderDetailsPopup || !orderDetails || !loader) return;

  orderPopupButtons.forEach(button => {
    button.addEventListener("click", () => {
      const orderUrl = button.getAttribute("data-order-url");
      const orderStatus = button.getAttribute("data-order-status");
      const orderNumber = button.getAttribute("data-order-number");

      updateOrderDetails(orderUrl, orderStatus, orderNumber);
      orderDetailsPopup.classList.remove("hidden");

      setTimeout(() => {
        orderDetails.classList.add("active");
      }, 100);

      body.style.overflow = "hidden";
    });
  });

  function closePopup() {
    orderDetailsPopup.classList.add("hidden");
    orderDetails.innerHTML = '';
    orderDetails.appendChild(loader);
    orderDetails.appendChild(closeButton);
    orderDetails.classList.remove("active");
    body.style.overflow = "auto";
  }

  orderDetailsPopup.addEventListener("click", () => {
    closePopup();
  });

  closeButton.addEventListener("click",()=>{
    closePopup();
  })

  orderDetails.addEventListener("click", event => {
    event.stopPropagation();
  });

  async function updateOrderDetails(orderUrl, orderStatus, orderNumber) {
    const orderTracking = document.querySelector("order-tracking-input");
    orderTracking?.updateOrderStatus(orderUrl, orderStatus, orderNumber, orderDetails);
  }
});

class FaqAccordion extends HTMLElement {
  constructor() {
    super();

    this.details = this.querySelector('.smooth-details');
    if (!this.details) return;
    this.summary = this.details.querySelector('summary');
    this.wrapper = this.details.querySelector('.content-wrapper');
    this.content = this.details.querySelector('.content');

    this.isAnimating = false;

    // If details is initially open, set height to content height
    if (this.details.hasAttribute('open')) {
      this.wrapper.style.height = `${this.content.offsetHeight}px`;
    } else {
      this.wrapper.style.height = '0px';
    }

    this.summary.addEventListener('click', this.handleSmoothEffect);
  }

  handleSmoothEffect = (e) => {
    e.preventDefault();
    if (this.isAnimating) return;

    this.isAnimating = true;

    if (this.details.hasAttribute('open')) {
      // COLLAPSING
      this.wrapper.style.height = `${this.content.offsetHeight}px`;
      requestAnimationFrame(() => {
        this.wrapper.style.height = '0px';
      });

      this.wrapper.addEventListener('transitionend', () => {
        this.details.removeAttribute('open');
        this.isAnimating = false;
      }, { once: true });

    } else {
      // EXPANDING
      this.details.setAttribute('open', '');
      this.wrapper.style.height = '0px';

      requestAnimationFrame(() => {
        this.wrapper.style.height = `${this.content.offsetHeight}px`;
      });

      this.wrapper.addEventListener('transitionend', () => {
        this.wrapper.style.height = 'auto'; 

        const rect = this.details.getBoundingClientRect();
        const isInView =
          rect.top >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);

        if (!isInView) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const offset = rect.top + scrollTop - (window.innerHeight * 0.3); 

          window.scrollTo({
            top: offset,
            behavior: 'smooth'
          });
        }

        this.isAnimating = false;
      }, { once: true });
    }
  }
  disconnectedCallback() {
    if (this.summary) {
      this.summary.removeEventListener('click', this.handleSmoothEffect);
    }
  }
}

customElements.define('faq-accordion', FaqAccordion);

document.addEventListener("DOMContentLoaded", () => {
  const triggerBtn = document.querySelector('.trigger-seo-popup');
  const seoPopup = document.querySelector('.seo-helper-popup');
  const closeBtns = document.querySelector('.close__seo-popup');

  if (triggerBtn && seoPopup && closeBtns) {
    triggerBtn?.addEventListener('click', function () {
      seoPopup.classList.add('visible');
      document.body.style.overflow = 'hidden';
    });
    closeBtns?.addEventListener('click', function () {
      seoPopup.classList.remove('visible');
      document.body.style.overflow = 'auto';
    });
  }
})

if (!customElements.get('pdp-faq-accordion')) {
  class PdpFaqAccordion extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('.smooth-details');
      if (!this.details) return;

      this.summary = this.details.querySelector('summary');
      this.wrapper = this.details.querySelector('.content-wrapper');
      this.content = this.details.querySelector('.content');
      this.isAnimating = false;

      if (this.details.hasAttribute('open')) {
        this.wrapper.style.height = `${this.content.offsetHeight}px`;
      } else {
        this.wrapper.style.height = '0px';
      }

      this.summary.addEventListener('click', this.toggleAccordion);
    }

    toggleAccordion = (e) => {
      e.preventDefault();
      if (this.isAnimating) return;
      this.isAnimating = true;

      const container = this.closest('.faq-container');
      const allAccordions = container.querySelectorAll('pdp-faq-accordion');

      allAccordions.forEach(el => {
        if (el !== this && el.querySelector('details[open]')) {
          const otherDetails = el.querySelector('details');
          const otherWrapper = el.querySelector('.content-wrapper');
          otherWrapper.style.height = `${otherWrapper.scrollHeight}px`;
          requestAnimationFrame(() => {
            otherWrapper.style.height = '0px';
          });
          otherWrapper.addEventListener('transitionend', () => {
            otherDetails.removeAttribute('open');
            otherWrapper.style.height = '0px';
          }, { once: true });
        }
      });

      if (this.details.hasAttribute('open')) {
        this.wrapper.style.height = `${this.content.offsetHeight}px`;
        requestAnimationFrame(() => {
          this.wrapper.style.height = '0px';
        });

        this.wrapper.addEventListener('transitionend', () => {
          this.details.removeAttribute('open');
          this.isAnimating = false;
        }, { once: true });

      } else {
        this.details.setAttribute('open', '');
        this.wrapper.style.height = '0px';

        requestAnimationFrame(() => {
          this.wrapper.style.height = `${this.content.offsetHeight}px`;
        });

        this.wrapper.addEventListener('transitionend', () => {
          this.wrapper.style.height = 'auto';

          const rect = this.details.getBoundingClientRect();
          const isInView =
            rect.top >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);

          if (!isInView) {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const offset = rect.top + scrollTop - (window.innerHeight * 0.3);

            window.scrollTo({
              top: offset,
              behavior: 'smooth'
            });
          }

          this.isAnimating = false;
        }, { once: true });
      }
    }

    disconnectedCallback() {
      if (this.summary) {
        this.summary.removeEventListener('click', this.toggleAccordion);
      }
    }
  }

  customElements.define('pdp-faq-accordion', PdpFaqAccordion);
}

if (!customElements.get('reorder-popup')) {
  class ReorderPopup extends HTMLElement {
    connectedCallback() {
      this.popupWrapper = document.querySelector('.reorder-popup-wrapper');
      this.tabButtons = this.popupWrapper.querySelectorAll('.reorder-tab');
      this.grids = this.popupWrapper.querySelectorAll('.reorder-product-grid');
      this.closeBtn = this.popupWrapper.querySelector('.reorder-close');
      this.innerTabButtons = this.popupWrapper.querySelectorAll('.inner-tab-button');
      this.innerTabContents = this.popupWrapper.querySelectorAll('.inner-tab-content');

      this.tabButtons.forEach(tab => {
        tab.addEventListener('click', () => {
          this.tabButtons.forEach(t => t.classList.remove('active'));
          tab.classList.add('active');

          const category = tab.dataset.category;
          let activeProducts = []
          this.grids.forEach(g => {
            g.classList.remove('active');
            if (g.dataset.productsTab === category) {
              g.classList.add('active');
              let productCards = g.querySelectorAll(".card-wrapper");
              activeProducts = []
              productCards.forEach((product)=>{
                activeProducts.push(product.querySelector(".card__heading a").getAttribute("data-product-handle"))
              })
            }
          });

          const allUpsellGrids = this.popupWrapper.querySelectorAll('.upsell-grid');
          allUpsellGrids.forEach(grid => grid.classList.add("hidden"));

          const currentUpsell = this.popupWrapper.querySelector(`.upsell-grid[data-upsell-for="${category}"]`);
          if (currentUpsell) {
            currentUpsell.classList.remove("hidden");
          }

          const rootEl = this.popupWrapper.querySelector('.reorder-content');
          if (rootEl) {
            rootEl.scrollTo({
              top: 0
            });
          }
          
          const clevertapData = {
            sectionTitle: "Repurchase",
            Category_Image: tab.querySelector("img").getAttribute("src") || '',
            Category_Name : tab.getAttribute("data-category") || '',
            Product_Names : activeProducts,
          }

          dataLayer.push({
            event: "Category_Name",
            sectionTitle: "Repurchase",
            Category_Image: tab.querySelector("img").getAttribute("src") || '',
            Category_Name : tab.getAttribute("data-category") || '',
            Product_Names : activeProducts,
            clevertap: clevertapData
          });
        });
      });

      this.innerTabButtons.forEach(button => {
        button.addEventListener('click', () => {
          const tab = button.dataset.innerTab;

          const sectionId = tab === 'repurchase-products' ? '#products-section' : '#upsell-section';
          const section = document.querySelector(sectionId);
          const rootEl = this.popupWrapper.querySelector('.reorder-content');
          if (rootEl && section) {
            const headerOffset = this.querySelector(".reorder-header").offsetHeight;
            const sectionTop = section.offsetTop;

            // Scroll with offset
            rootEl.scrollTo({
              top: sectionTop - headerOffset,
              behavior: 'smooth'
            });
          }
        });
      });

      document.querySelectorAll('[data-reorder-trigger]').forEach(trigger => {
        trigger.addEventListener('click', () => this.openPopup());
      });

      this.closeBtn?.addEventListener('click', () => this.closePopup());

      this.popupWrapper.addEventListener('click', (e) => {
        if (e.target === this.popupWrapper) {
          this.closePopup();
        }
      });

      this.observeSections();

      if (localStorage.getItem('triggerReorderPopup') === 'true') {
        localStorage.removeItem('triggerReorderPopup');
        this.openPopup();
      }
    }

    observeSections() {
      const rootEl = this.popupWrapper.querySelector('.reorder-content');
      const productsSection = document.getElementById('products-section');
      const upsellSection = document.getElementById('upsell-section');
      if (!rootEl || !productsSection || !upsellSection) return;

      let lastActiveTab = null;

      rootEl.addEventListener('scroll', () => {
        const rootTop = rootEl.scrollTop;

        const productTop = productsSection.offsetTop;
        const upsellTop = upsellSection.offsetTop;

        // Calculate distance of each section's top from scroll top
        const distanceToProduct = Math.abs(rootTop - productTop);
        const distanceToUpsell = Math.abs(rootTop - upsellTop);

        const activeTab = distanceToUpsell < distanceToProduct ? 'upsell' : 'repurchase-products';

        if (activeTab !== lastActiveTab) {
          lastActiveTab = activeTab;
          let productList = this.tabActiveProducts(activeTab);

          const clevertapData = {
            Tab_Name: activeTab,
            Products_Name : productList
          }

          dataLayer.push({
            event: "Repurchase_Tabs",
            Tab_Name: activeTab,
            Products_Name : productList,
            clevertap: clevertapData
          });
        }

        this.innerTabButtons.forEach(btn => {
          btn.classList.toggle('active', btn.dataset.innerTab === activeTab);
        });
      });
    }

    openPopup() {
      const isLoggedIn = this.popupWrapper.dataset.loggedIn === 'true';
      if (!isLoggedIn) {
        kpHandleLogin(window.location.href);
        return;
      }

      this.popupWrapper?.classList.add('show');
      document.body.classList.add('reorder-overflow-hidden');

      const notifyPopup = document.querySelector('.notify-me-success-message-popup');
      if (notifyPopup) {
        notifyPopup.classList.add('z-106-b-4');
      }

      this.innerTabButtons.forEach(btn => btn.classList.remove('active'));
      const defaultTab = this.popupWrapper.querySelector('[data-inner-tab="repurchase-products"]');
      if (defaultTab) defaultTab.classList.add('active');
    }

    closePopup() {
      const popup = this.popupWrapper.querySelector('.reorder-popup');
      if (!popup) return;

      popup.classList.add('slide-out');

      popup.addEventListener(
        'transitionend',
        () => {
          this.popupWrapper?.classList.remove('show');
          popup.classList.remove('slide-out');
          document.body.classList.remove('reorder-overflow-hidden');
          const notifyPopup = document.querySelector('.notify-me-success-message-popup');
          if (notifyPopup) {
            notifyPopup.classList.remove('z-106-b-4');
          }
        },
        { once: true }
      );

      const clevertapData = {
        sectionTitle: "Repurchase",
      }

      dataLayer.push({
        event: "Close_Repurchase",
        sectionTitle: "Repurchase",
        clevertap: clevertapData
      });
    }

    tabActiveProducts(activeTab) {
      const productListWrapper = 
        activeTab === 'upsell' 
          ? this.querySelector(".upsell-grid:not(.hidden)") 
          : this.querySelector(".reorder-product-grid.active");

      if (!productListWrapper) {
        return [];
      }

      const productList = Array.from(
        productListWrapper.querySelectorAll(".card-wrapper")
      ).map(product => 
        product.querySelector(".card__heading a")?.getAttribute("data-product-handle")
      ).filter(Boolean);
      return productList;
    }
  }

  customElements.define('reorder-popup', ReorderPopup);
}

if (!customElements.get('reorder-login-button')) {
  class ReorderLoginButton extends HTMLElement {
    connectedCallback() {
      const redirectUrl = window.location.origin;
      const triggerPopup = this.dataset.triggerPopup === 'true';

      this.querySelector('button').addEventListener('click', () => {
        if (triggerPopup) {
          localStorage.setItem('triggerReorderPopup', 'true');
        }
        kpHandleLogin(redirectUrl);
      });
    }
  }

  customElements.define('reorder-login-button', ReorderLoginButton);
}

document.addEventListener("DOMContentLoaded",()=>{
  let editProfile = document.querySelector(".side-bar__profile-edit");
  let userDataPopupOverlay = document.querySelector(".customer_data-popup-overlay");
  if (editProfile && userDataPopupOverlay) {
    editProfile.addEventListener("click",()=>{
      userDataPopupOverlay.classList.remove("hidden");
    })

    userDataPopupOverlay.addEventListener("click",(event)=>{
      if (event.target == userDataPopupOverlay) {
        userDataPopupOverlay.classList.add("hidden");
      }
    })
  }
})


document.addEventListener("DOMContentLoaded", () => {
  const helpCategoriesSection = document.querySelector(".help-categories-section");
  const helpCategories = document.querySelectorAll(".help-categories--block, .help-recent-purchase");

  if (helpCategoriesSection && helpCategories ) {
    const handleSectionToggle = (triggerElement) => {
      const mapedSectionName = triggerElement.getAttribute("data-maped-section");
      if (!mapedSectionName) return;

      const mapedSection = document.querySelector(`.account-faq-section[data-maped-block="${mapedSectionName}"]`);
      if (!mapedSection) return;

      helpCategoriesSection.classList.add("hidden");
      mapedSection.classList.remove("hidden");

      const backButton = mapedSection.querySelector(".profile-page-back-button");
      backButton?.addEventListener("click", (event) => {
        event.preventDefault();
        helpCategoriesSection.classList.remove("hidden");
        mapedSection.classList.add("hidden");
      });
    };

    helpCategories.forEach((category) => {
      category.addEventListener("click", () => handleSectionToggle(category));
    });
  }
});

if (!customElements.get('cart-strip-copy')) {
  class CartStripCopy extends HTMLElement {
    connectedCallback() {
      this.initCopyFeature();
    }

    initCopyFeature() {
      const code = this.dataset.code;
      const button = this.querySelector('.copy-btn');

      if (!code || !code.trim() || !button) return;

      const iconCopy = this.querySelector('.icon-copy');
      const iconCheck = this.querySelector('.icon-check');

      button.addEventListener('click', () => {
        if (!navigator.clipboard) return;

        navigator.clipboard.writeText(code).then(() => {
          if (iconCopy && iconCheck) {
            iconCopy.classList.add('hidden');
            iconCheck.classList.remove('hidden');
            setTimeout(() => {
              iconCopy.classList.remove('hidden');
              iconCheck.classList.add('hidden');
            }, 2000);
          }
        });
      });
    }
  }

  customElements.define('cart-strip-copy', CartStripCopy);
}

class CustomerDataForm extends HTMLElement {
  constructor() {
    super();
    this.currTab = null;
  }

  connectedCallback() {
    this.closeButton = this.querySelector(".customer_data-popup-close");
    this.popupcontent = this.querySelector(".customer_data-popup")
    this.form = this.querySelector(".customer_data-form");
    this.submitButton = this.querySelector(".customer_data-submit-btn");
    this.finalErrorContainer = this.querySelector(".customer_data-form-third-tab .customer_data-form-error");
    this.successContainer = this.querySelector(".customer_data-form-success");
    this.dateErrorMessage = this.querySelector(".customer_data-form-second-tab .customer_data-form-error");
    this.loader = this.querySelector(".customer_data-submit-loader");
    this.tabs = [...this.querySelectorAll(".customer_data-form-tab")];
    this.currTab = this.querySelector(".customer_data-form-first-tab");

    this.bindEvents();

    window.addEventListener('scroll', () => {
      const shopByConcernSection = document.querySelector(".shop-by-concern-section");
      if(shopByConcernSection && this.isInView(shopByConcernSection) && sessionStorage.getItem("show_customer_form") !== "false"){
        this.showPopup();
      } 
    });
  }

  bindEvents() {
    this.closeButton?.addEventListener("click", () => this.hidePopup());

    this.addEventListener("click", (event) => {
      if (event.target === this) this.hidePopup();
    });

    this.querySelectorAll(".customer_data-prev-btn").forEach((btn) =>
      btn.addEventListener("click", () =>
        this.showNextTab(btn.dataset.prev)
      )
    );

    this.querySelectorAll(".customer_data-save-btn").forEach((btn) =>
      btn.addEventListener("click", (e) => this.handleSave(e, btn))
    );

    this.submitButton?.addEventListener("click", (e) => {
      e.preventDefault();
      this.finalErrorContainer.textContent = "";
      if (this.validateForm()) this.submitForm();
    });
  }

  isInView(element) {
    const rect = element.getBoundingClientRect();
    return rect.top >= 0 && rect.top <= window.innerHeight / 2;
  }

  showPopup() {
    this.classList.remove("hidden");
    setTimeout(() => {
      this.popupcontent.classList.add("active");
    }, 200);
    document.body.style.overflow = "hidden";
  }

  hidePopup() {
    this.classList.add("hidden");
    this.popupcontent.classList.remove("active");
    sessionStorage.setItem("show_customer_form", "false");
    document.body.style.overflow = "auto";

    let firstTab = this.querySelector(".customer_data-form-first-tab");

    if (this.currTab != firstTab) {
      firstTab.classList.remove("hidden");
      this.currTab.classList.add("hidden");
      this.currTab = firstTab;
    }
  }

  handleSave(event, button) {
    event.preventDefault();
    if (button.closest(".customer_data-form-second-tab")) {
      const dob = this.form.querySelector("input[name=dob]")?.value.trim();
      const today = new Date().toISOString().split("T")[0];
      if (!dob) {
        return this.showMessage(this.dateErrorMessage, "Please select a valid date");
      }
      if (dob && dob >= today) {
        return this.showMessage(this.dateErrorMessage, "Date of birth cannot be in the future.");
      }
    }
    this.showNextTab(button.dataset.next);
  }

  showNextTab(index) {
    const tabs = ["", "first", "second", "third"];
    let tab = tabs[index] || "";

    const nextTab = this.querySelector(`.customer_data-form-${tab}-tab`);
    if (!nextTab) return;
    this.currTab?.classList.add("hidden");
    nextTab.classList.remove("hidden");
    this.currTab = nextTab;
  }

  validateForm() {
    const skincareGoals = [...this.querySelectorAll(".customer_data-form-third-tab input[type='checkbox']:checked")]
      .map(opt => opt.value);

    if (!skincareGoals.length) {
      this.showMessage(this.finalErrorContainer, "Please select at least one skincare goal.");
      return false;
    }
    return true;
  }

  async submitForm() {
    this.loader.classList.remove("hidden");

    const formData = new FormData(this.form);
    const skincareGoals = [...this.querySelectorAll(".customer_data-form-third-tab input[type='checkbox']:checked")]
      .map(opt => {
        formData.delete(opt.name);
        return opt.value;
      });

    formData.append("customerId", this.form.dataset.customerId || "");
    formData.set("birthdate", this.form.querySelector("input[name=dob]")?.value || "");
    formData.set("gender", this.querySelector("input[name=gender]:checked")?.value || "");
    formData.set("skincareGoal", skincareGoals.join(","));
    formData.append("storeName", "mcaffeine");

    try {
      const response = await fetch("https://mcaffeineCustomer.marmeto.com/api/update_customer_metafields", {
        method: "POST",
        body: formData,
      });

      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

      const data = await response.json();
      this.pushToClevertap({
        dob: formData.get("birthdate"),
        gender: formData.get("gender"),
        skincareGoals : skincareGoals
      });
      await this.showMessage(this.successContainer, "Data Saved Successfully");
      setTimeout(() => {
        this.hidePopup();
      }, 1000);
    } catch (error) {
      console.error(error);
      this.showMessage(this.finalErrorContainer, "Failed to submit. Please try again later.");
    } finally {
      this.loader.classList.add("hidden");
    }
  }

  pushToClevertap({ dob, gender, skincareGoals }) {
    clevertap.profile.push({
      "Site": {
        "Gender": gender,    
        "DOB": dob ? new Date(dob) : undefined,
        "Skincare Goal": skincareGoals.join(',') ,
      }
    });
  }

  showMessage(container, message, timeout = 3000) {
    if (!container) return;
    container.textContent = message;
    if (timeout) {
      setTimeout(() => { container.textContent = ""; }, timeout);
    }
  }
}

customElements.define("customer-data-form", CustomerDataForm);

document.addEventListener("DOMContentLoaded", () => {
  const customerForm = document.querySelector(".customer-form-section");
  const formSubmitButton = document.querySelector(".cf_submit-btn");

  if (!formSubmitButton || !customerForm) return;

  const loader = formSubmitButton.querySelector(".cf_submit-btn-loader");
  const buttonText = formSubmitButton.querySelector(".cf_submit-btn-text");
  const formMessage = customerForm.querySelector(".cf_messsage");

  function showMessage(text, type = "success", duration = 4000) {
    formMessage.textContent = text;
    formMessage.classList.remove("hidden", "error", "success");
    formMessage.classList.add(type);

    setTimeout(() => {
      formMessage.textContent = "";
      formMessage.classList.add("hidden");
      formMessage.classList.remove(type);
      formSubmitButton.disabled = false;
    }, duration);
  }

  function resetButton() {
    loader.classList.add("hidden");
    buttonText.classList.remove("hidden");
  }

  formSubmitButton.addEventListener("click", async (e) => {
    e.preventDefault();
    formSubmitButton.disabled = true;

    const email = customerForm.querySelector("input[name=email]")?.value.trim();
    const dob = customerForm.querySelector("input[name=dob]")?.value;
    const anniversary = customerForm.querySelector("input[name=anniversary]")?.value;
    const skincareGoals = [...customerForm.querySelectorAll("input[type='checkbox']:checked")].map(opt => opt.value);
    const gender = customerForm.querySelector("input[name=gender]:checked")?.value;

    if (!email || (!dob && !gender && !anniversary && skincareGoals.length === 0)) {
      showMessage("Please fill email and at least one other value.", "error");
      return;
    }

    if (customerForm.getAttribute("data-custom-id") === "") {
      showMessage("Please Log in before saving", "error");
      return;
    }

    const selectedDate = new Date(dob);
    const selectedAnniversary = new Date(anniversary);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    selectedDate.setHours(0, 0, 0, 0);
    selectedAnniversary.setHours(0, 0, 0, 0);

    if (selectedAnniversary >= today) {
      showMessage("Anniversary date cannot be in the future.", "error");
      return;
    }

    if (selectedDate >= today) {
      showMessage("Date of birth cannot be today or in the future.", "error");
      return;
    }

    loader.classList.remove("hidden");
    buttonText.classList.add("hidden");

    try {
      const formData = new FormData();
      formData.append("email", email);
      formData.append("customerId", customerForm.getAttribute("data-custom-id"));
      formData.set("birthdate", dob);
      formData.set("gender", gender);
      formData.set("skincareGoal", skincareGoals.join(","));
      formData.set("anniversary", anniversary);
      formData.append("storeName", "mcaffeine");

      const response = await fetch("https://mcaffeineCustomer.marmeto.com/api/update_customer_metafields", {
        method: "POST",
        body: formData,
      });

      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

      await response.json();

      clevertap.profile.push({
        "Site": {
          "Gender": gender,
          "DOB": dob ? new Date(dob) : undefined,
          "Anniversary": anniversary? new Date(anniversary):undefined,
          "Skincare Goal": skincareGoals.join(","),
        }
      });

      resetButton();
      showMessage("Data Saved Successfully", "success");

    } catch (error) {
      console.error(error);
      resetButton();
      showMessage("There was an error, please try again later", "error");
    }
  });
});

// Changes for Add to cart confetti starts
document.addEventListener('DOMContentLoaded', function () {
  const buttonClasses = [
    'product-form',
    'ins-shoppable-video-card-add-to-cart',
    'product-form__submit'
  ];
  const addedButtons = new WeakSet();

  function animateCustomEffect(button) {
    button.classList.remove('animate');
    void button.offsetWidth;
    button.classList.add('animate');

    setTimeout(() => {
      button.classList.remove('animate');
    }, 700);
  }

  function addCustomAnimationToButtons() {
    buttonClasses.forEach(buttonClass => {
      const buttons = document.querySelectorAll(`.${buttonClass}`);

      buttons.forEach(button => {
        if (!addedButtons.has(button)) {
          addedButtons.add(button);

          button.classList.add('confetti-button');

          button.addEventListener('click', function (e) {
            animateCustomEffect(button);
          });
        }
      });
    });
  }

  addCustomAnimationToButtons();

  const observer = new MutationObserver(() => {
    addCustomAnimationToButtons();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
// Changes for Add to cart confetti ends
if (!customElements.get('freebie-accordion')) {
  class FreebieAccordion extends HTMLElement {
    connectedCallback() {
      this.progressText = this.querySelector(".freebie-progress-text");
      this.offerList = this.querySelector(".freebie-offers-list");
      this.counter = this.querySelector(".global-freebie-counter");

      if (!this.progressText || !this.offerList || !this.counter) return;

      this.updateProgress();

      this.progressText.addEventListener("click", () => this.toggle());
    }

    toggle() {
      this.offerList.classList.toggle("open");
      this.progressText.classList.toggle("active");
    }

    updateProgress() {
      let unlocked = parseInt(this.counter.dataset.unlocked) || 0;
      let total = parseInt(this.counter.dataset.total) || 0;

      if (total > 0) {
        let percent = (unlocked / total) * 100;
        let progressCircle = this.counter.querySelector(".progress-circle");

        if (progressCircle) {
          progressCircle.style.background = `conic-gradient(
            #00c853 ${percent * 3.6}deg, 
            #333 ${percent * 3.6}deg 360deg
          )`;
        }
      }
    }
  }

  customElements.define("freebie-accordion", FreebieAccordion);
}

// Changes for Homepage firework confetti starts

// const duration = 5 * 1000,
//   animationEnd = Date.now() + duration,
//   defaults = {
//     startVelocity: 30,
//     spread: 360,
//     ticks: 60,
//     zIndex: 0,
//     colors: ['#d43e3d', '#F7EF8A', '#EQAA3E']
//   };

// function randomInRange(min, max) {
//   return Math.random() * (max - min) + min;
// }

// if (!sessionStorage.getItem('confettiShown')) {
//   const interval = setInterval(function () {
//     const timeLeft = animationEnd - Date.now();

//     if (timeLeft <= 0) {
//       clearInterval(interval);
//     }

//     const particleCount = 100 * (timeLeft / duration);

//     confetti(
//       Object.assign({}, defaults, {
//         particleCount,
//         origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 },
//       })
//     );
//     confetti(
//       Object.assign({}, defaults, {
//         particleCount,
//         origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 },
//       })
//     );
//   }, 250);

//   sessionStorage.setItem('confettiShown', 'true');
// }

// Changes for Homepage firework confetti ends